import { TAppState } from '../../types/appState';

export const mobileSideSelector = (state: TAppState) => state.mobileSide;
